// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__2Fjz6","title":"Header_title__23ya5","center":"Header_center__5c778","right":"Header_right__2zfVa","cancel":"Header_cancel__2Rthi"};